import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { LanguageService } from '../../../services/language.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() title: string;
  @Input() isStaff: boolean;
  @Input() profileIcon: boolean;
  @Output() goBack = new EventEmitter();
  language$ = this.languageService.language$;
  language: string;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.language$.subscribe(lng => this.language = lng.toUpperCase());
  }

  toggleLanguage() {
    this.language = this.language === 'EN' ? 'SR' : 'EN';
    this.languageService.setLanguage(this.language.toLowerCase());
  }

  goBackEmit() {
    this.goBack.emit(null);
  }
}
